import React from 'react';
import { HeroSection } from './components/HeroSection';
import { PainSection } from './components/PainSection';
import { SolutionSection } from './components/SolutionSection';
import { WhatYouGet } from './components/WhatYouGet';
import { ForYouSection } from './components/ForYouSection';
import { HowItWorks } from './components/HowItWorks';
import { ResultsSection } from './components/ResultsSection';
import { FAQSection } from './components/FAQSection';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-cream font-sans text-espresso selection:bg-sage/30" data-id="element-0">
      <main data-id="element-1">
        <HeroSection data-id="element-2" />
        <PainSection data-id="element-3" />
        <SolutionSection data-id="element-4" />
        <WhatYouGet data-id="element-5" />
        <ForYouSection data-id="element-6" />
        <HowItWorks data-id="element-7" />
        <ResultsSection data-id="element-8" />
        <FAQSection data-id="element-9" />
        <FinalCTA data-id="element-10" />
      </main>

      <Footer data-id="element-11" />
    </div>;
}